var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94244 14.1121H3.48486V11.6121H8.94244V14.1121ZM36.5155 14.1121H21.9129V11.6121H36.5155V14.1121Z",
    fill: "#232F3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0576 25.8875L36.5151 25.8875L36.5151 28.3875L31.0576 28.3875L31.0576 25.8875ZM3.48454 25.8874L18.0871 25.8875L18.0871 28.3874L3.48454 28.3874L3.48454 25.8874Z",
    fill: "#232F3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3255 16.5319C18.3539 16.5319 19.9982 14.8876 19.9982 12.8592C19.9982 10.8308 18.3539 9.18652 16.3255 9.18652C14.2972 9.18652 12.6528 10.8308 12.6528 12.8592C12.6528 14.8876 14.2972 16.5319 16.3255 16.5319ZM16.3255 19.0319C19.7346 19.0319 22.4982 16.2683 22.4982 12.8592C22.4982 9.45013 19.7346 6.68652 16.3255 6.68652C12.9164 6.68652 10.1528 9.45013 10.1528 12.8592C10.1528 16.2683 12.9164 19.0319 16.3255 19.0319Z",
    fill: "#232F3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6745 23.4676C21.6461 23.4676 20.0018 25.1119 20.0018 27.1403C20.0018 29.1687 21.6461 30.813 23.6745 30.813C25.7028 30.813 27.3472 29.1687 27.3472 27.1403C27.3472 25.1119 25.7028 23.4676 23.6745 23.4676ZM23.6745 20.9676C20.2654 20.9676 17.5018 23.7312 17.5018 27.1403C17.5018 30.5494 20.2654 33.313 23.6745 33.313C27.0836 33.313 29.8472 30.5494 29.8472 27.1403C29.8472 23.7312 27.0836 20.9676 23.6745 20.9676Z",
    fill: "#232F3E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSort);
export default __webpack_public_path__ + "static/media/ic_sort.7856176e42fff0f14a0813c2a6fb4130.svg";
export { ForwardRef as ReactComponent };